@if (visible$ | async) {
  <section class="flex w-full flex-col gap-4" [formGroup]="form">
    @if (canOverride()) {
      <div class="flex">
        <div class="flex grow">Forfeit deposit as a cancellation fee</div>
        <mat-slide-toggle
          formControlName="shouldForfeit"
          ptElementTarget="deposit-forfeiture-toggle"
          (blur)="touched()"
        />
      </div>

      @if (form.controls.shouldForfeit.value) {
        <mat-form-field subscriptSizing="dynamic">
          <mat-label>Amount to forfeit</mat-label>
          <span matTextPrefix>$&nbsp;</span>
          <input
            matInput
            type="number"
            step="0.01"
            formControlName="amountDollars"
            ptElementTarget="deposit-forfeiture-amount"
            [attr.min]="minAmountDollars"
            [attr.max]="maxAmountDollars"
            (blur)="touched()"
          />
          @if (amountExceedsDeposit) {
            <mat-error>The amount cannot exceed the paid deposit.</mat-error>
          }
        </mat-form-field>

        @if (feeAttributionView$ | async; as view) {
          <button
            type="button"
            class="hover:text-primary-400 -mt-2 flex cursor-pointer flex-row items-center gap-1 self-start border-0 bg-transparent p-0 text-left text-sm text-slate-400 hover:underline"
            matTooltipShowDelay="500"
            matTooltip="Change who the fee is allocated to"
            ptElementTarget="deposit-forfeiture-fee-attribution"
            [matMenuTriggerFor]="feeAttributionMenu"
          >
            <mat-icon class="icon-xs opacity-50"
              >account_balance_wallet</mat-icon
            >
            <span ptElementTarget="deposit-forfeiture-fee-attribution-summary">
              Fee allocated to {{ view.recipientInSentence }}
              @if (view.isDefault) {
                (default)
              }
            </span>
          </button>

          <mat-menu #feeAttributionMenu="matMenu">
            @for (option of view.options; track option.value) {
              <button
                mat-menu-item
                type="button"
                [attr.aria-checked]="option.value === view.selected"
                (click)="selectFeeAttribution(option.value)"
              >
                <mat-icon>
                  {{ option.value === view.selected ? 'check' : '' }}
                </mat-icon>
                <span>
                  {{ option.label }}
                  @if (option.isDefault) {
                    <span class="text-slate-500">(default)</span>
                  }
                </span>
              </button>
            }
          </mat-menu>
        }
      } @else if (requiresOverrideReason) {
        <mat-form-field subscriptSizing="dynamic">
          <mat-label>Why is the automatic forfeiture being disabled?</mat-label>
          <pr-content-editor
            formControlName="overrideReason"
            placeholder="Reason for not forfeiting the deposit"
            ptElementTarget="deposit-forfeiture-override-reason"
            [menuEnabled]="false"
            (blur)="touched()"
          />
          <mat-error>A reason is required.</mat-error>
        </mat-form-field>
      }
    } @else if (form.controls.shouldForfeit.value) {
      @if (feeAttributionView$ | async; as view) {
        <div class="flex flex-row items-center gap-1 text-sm text-slate-400">
          <mat-icon class="icon-xs opacity-50">account_balance_wallet</mat-icon>
          <span ptElementTarget="deposit-forfeiture-fee-attribution-summary">
            Fee allocated to {{ view.recipientInSentence }}
            @if (view.isDefault) {
              (default)
            }
          </span>
        </div>
      }
    }
  </section>
}
